module.exports = __webpack_public_path__ + "static/direct-democracy-c7530c2584643857f3941ec843288b53.jpg";